/* eslint-disable import/first,import/order */
import React, {Component} from 'react';
import _ from 'lodash';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import ModalBaseLayout from '../ModalBaseLayout';
import {ActionModalHide} from '../../../store/actions/actions-modal';
import {
  ActionRemoveUserFile, ActionDeleteContact, ActionRemoveContactFromFavorite, ActionRemoveUser,
  ActionAdminRemoveUser,
} from '../../../store/actions/actions-user';
import {ActionDeleteVideoRecord} from '../../../store/actions/actions-request';
import {removeVideoPoll} from '../../../api/video-poll.api';

class ModalConfirmRemove extends Component {
  constructor(props) {
    super(props);

    this.settings = ModalBaseLayout.getInitialSettings({
      className: 'modal-center modal-remove',
      closeButton: true,
      keyboard: true,
    });
  }

  onRemoveClick = async () => {
    const {data} = this.props;
    switch (data.type) {
    case 'removeVideoRecord':
      this.props.ActionDeleteVideoRecord(data.videoRecordId);
      break;
    case 'removeUserFile':
      this.props.ActionRemoveUserFile(data.fileId);
      break;
    case 'removeContact':
      this.props.ActionDeleteContact(data.userId);
      break;
    case 'removeUser':
      this.props.ActionRemoveUser(data.userId);
      break;
    case 'adminRemoveUser':
      await this.props.ActionAdminRemoveUser(data.userId).then(async () => {
        if (_.isFunction(data.callback)) {
          await data.callback();
        }
      });
      break;
    case 'removeVideoPoll':
      removeVideoPoll(data.videoPollId);
      break;
    default:
    }
    this.onCancelClick();
  };

  onCancelClick = () => {
    this.props.ActionModalHide();
  };

  render() {
    const {text} = this.props.data;

    return (
      <ModalBaseLayout {...this.settings}>
        <div className="modal-container">
          <div className="modal-content">
            <div className="modal-title">{text}</div>
            <div className="btn-wrap">
              <button className="btn btn-danger" onClick={this.onRemoveClick}>Удалить</button>
              <button className="btn btn-default btn-conture" onClick={this.onCancelClick}>Отмена</button>
            </div>
          </div>
        </div>
      </ModalBaseLayout>
    );
  }
}

ModalConfirmRemove.propTypes = {};

ModalConfirmRemove.defaultProps = {
  data: {},
};

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    ActionModalHide,
    ActionDeleteVideoRecord,
    ActionRemoveUserFile,
    ActionDeleteContact,
    ActionRemoveContactFromFavorite,
    ActionRemoveUser,
    ActionAdminRemoveUser,
  }, dispatch);
}

export default connect(null, mapDispatchToProps)(ModalConfirmRemove);
